module.exports = __webpack_public_path__ + "img/shuixi05.ab5568d2.png";